module.exports = __webpack_public_path__ + "img/1x.ad15f71.jpg";